var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"minting-details py-16 w-100 mx-auto px-10 xl:px-48 text-center"},[_c('p',{staticClass:"font-Guru text-center text-5xl mb-10"},[_vm._v(" Get your Shamanzs in high resolution! ")]),_c('p',[_vm._v(" Now you can enjoy your Shamanzs in 3500 * 3500 px. "),_c('a',{attrs:{"href":"https://shamanzs.com/hires"}},[_vm._v("Download yours now!")])])])
}]

export { render, staticRenderFns }